<template>
  <v-btn
    color="deep-purple"
    dark
    depressed
    class="mr-2"
    height="40"
    @click="$emit('click')"
  >
    <v-icon left>mdi-database-import</v-icon>
    {{ $t("initial_state") }}
  </v-btn>
</template>

<script>
export default {
  name: "WarehouseButtonInitialState",
};
</script>
